import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

/**
 * Service to help track navigation history within the application.
 * Stores the previous and current URLs for navigation purposes.
 */
export class NavigationHelperService {

  private readonly dealGroupSlugs: Record<string, string> = {
    'E8020C3E-4339-4C7C-A969-525D01B5D106': 'ccaas',
    '8C36243D-E2D5-431C-93E9-533AEDB0992A': 'fao',
    '43327BBB-C31A-4F44-BA59-7C2AD5F2A3F9': 'it-labor-rates',
    '32AE4432-7DAD-4E18-9FE8-C87953CA3ED5': 'it-services',
    '7C6CE53D-0848-4246-9778-D2B08B7EB51F': 'procurement',
    '2D45DEB9-12F6-48AF-A50C-E43BD9DB7764': 'telecom'
  };

  /**
   * The URL visited before the current navigation.
   */
  private previousUrl: string | null = null;

  /**
   * The current URL after navigation.
   */
  private currentUrl: string | null = null;

  /**
   * Initializes the service and subscribes to router navigation events to track URLs.
   * @param router The Angular Router used for navigation tracking.
   */
  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {

        if (event?.url === '/dummy') {
          // do nothing
        }
        else if (this.currentUrl === (event?.urlAfterRedirects || event?.url || './')) {
          // do nothing
        }
        else {
          this.previousUrl = this.currentUrl;
          this.currentUrl = event?.urlAfterRedirects || event?.url || './';
        }

      });
  }

  /**
   * Returns the URL visited before the current navigation.
   * @returns The previous URL, or null if not available.
   */
  getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  /**
   * Returns the URL slug for a given deal group ID, or null if not found.
   */
  getDealGroupSlug(dealGroupId: string | null | undefined): string | null {
    if (!dealGroupId) return null;
    return this.dealGroupSlugs[dealGroupId.toUpperCase()] ?? null;
  }

  /**
   * Navigates to the scenario editor for the given deal group and deal ID.
   * Produces /scenarios/{slug}/scenario?id=dealId when the slug is known,
   * falling back to /scenario?id=dealId for unrecognised deal groups.
   */
  navigateToScenario(dealGroupId: string | null | undefined, dealId: string): void {
    const slug = this.getDealGroupSlug(dealGroupId);

    if (slug) {
      this.router.navigate(['/scenarios', slug, 'scenario'], { queryParams: { id: dealId } });
    }
    else {
      this.router.navigate(['/scenario'], { queryParams: { id: dealId } });
    }
  }
}


